import { DateTranslate } from "@/app/core/util/DateTranslater";
import { ComplainHelper } from "@/app/core/util/helpers/ComplainHelper";
import { DateHelper } from "@/app/core/util/helpers/DateHelper";
import React, { useState, useEffect } from "react";
import AdminCompanyModal from "../../../companies/main/components/AdminCompanyModal";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import { toast } from "react-toastify";
import ComplainModal from "@/app/core/layouts/main-components/complain/ComplainModal";
import ComplainEditModal from "./ComplainEditModal";
import { EmailController } from "@/app/core/base/controllers/EmailController";
import { TimelineController } from "@/app/core/base/controllers/TimelineController";
import Storage from "@/app/core/util/Storage";
import ComplainResponseModal from "./ComplainResponseModal";
import { ServicesController } from "@/app/core/base/controllers/ServicesController";
import { use } from "react";
import CheckMobile from "@/app/core/util/Screen";

export default function ComplainCard({ data, reload }) {
    const [showModal, setShowModal] = useState(false);
    const [showComplainModal, setShowComplainModal] = useState(false);
    const [showResponseModal, setShowResponseModal] = useState(false);
    const [selectedServices, setSelectedServices] = useState([]);
    const userData = Storage.getUserData();

    function getBorderColor(){
        switch (data.status) {
            case ComplainHelper.Status.Open:
                return "border-info";
            case ComplainHelper.Status.Done:
                return "border-success";
            case ComplainHelper.Status.Unsolved:
                return "border-danger";
            case ComplainHelper.Status.Deleted:
                return "border-danger";
            case ComplainHelper.Status.Responded:
                return "border-secondary";
            case ComplainHelper.Status.Solved:
                return "border-success";
                
            default:
                return "border-secondary";
        }
    }

    useEffect(()=>{
        if (data && data.selectedServices) {
            loadSelectedServices(data.selectedServices);
        }
    }, [data])

    async function loadSelectedServices(serviceIds) {
        if (serviceIds.length > 0) {
            const services = await ServicesController.ListSelectedServices(serviceIds);
            setSelectedServices(services);
        }
    }

    async function deleteComplain(){
        if(window.confirm(Message.DeleteConfirm)){
            let newData = data;
            newData.status = ComplainHelper.Status.Deleted;

            await ComplainController.Update(newData);
            toast.success(Message.DeleteSuccess);
            reload()
        }
    }

    async function sendDirect() {
        if(window.confirm(Message.Confirm)){
            let newData = data;
            newData.status = ComplainHelper.Status.Open;
            await ComplainController.Update(newData);

            
            EmailController.SendCompanyComplain(data);
            EmailController.SendUserComplain(data);
            TimelineController.Insert({description: `${userData.name} enviou os emails para o cliente e para a empresa`, complainId: data.id,});
        }
    }

    function legible(name) {
        if (name.length > 150) {
          let newName = name.substr(0, 150) + "...";
          return newName;
        } else {
          return name;
        }
      }

    function legibleTitle(name) {
        if (name.length > 80) {
          let newName = name.substr(0, 80) + "...";
          return newName;
        } else {
          return name;
        }
      }

    return (
        <div className={`block block-rounded block-bordered border-3x ${getBorderColor()} ribbon ribbon-${data && data.orderId && data.orderStatus == "paid"? "success" : data && data.orderId && data.orderStatus == "pending" ? "info" : "danger" }`}>
            {data && data.orderId && data.orderStatus == "paid" ?
                <div class="ribbon-box">
                    <i class="fa fa-shopping-cart mr-1"></i> Pago
                </div>
            : data && data.orderId && data.orderStatus == "failed" ?
                <div class="ribbon-box">
                    <i class="fa fa-shopping-cart mr-1"></i> Falha no pagamento
                </div>
            : data && data.orderId && data.orderStatus == "pending" ?
            <div class="ribbon-box">
                <i class="fa fa-shopping-cart mr-1"></i> Pagamento pendente
            </div>:""}
            {CheckMobile() ? 
            <div className=" bg-dark text-white">
                <div className="block-title d-flex">
                    <i className="far fa-angry fa-2x mr-3 py-4" />
                    <p className="pb-0 mb-0">
                        <h3 className="m-0 text-white">{data && data.title && legibleTitle(data.title)} - {data && data.title && ComplainHelper.TranslateStatus(data.status)}</h3>
                        <span className="font-size-sm mr-3">ID: {data && !data.oldId ? data.createdDate.seconds :  data.oldId}</span>
                        <span className="font-size-sm mr-3">Nome: {data && data.user && data.user.name}</span>
                        <span className="font-size-sm mr-3">Telefone: {data && data.phone && data.phone}</span>
                        <br />
                        <small className="text-white">{data && data.createdDate && DateTranslate(data.createdDate)}</small> - {data && data.company && data.company.verified == true ? <i className="si si-check text-success" /> : <i className="si si-close text-danger" />} Empresa: {data && data.company && data.company.name}
                    </p>
                </div>
                <br/>
                <div className="text-center">
                    <a className="btn btn-warning btn-sm text-dark" href={`#/empresa/${data && data.companyId}?nome=${data && data.company && data.company.name}`} target="_blank"><i className="fa fa-search" /> Ver Empresa</a>
                    <button className="btn btn-white btn-sm" onClick={()=> setShowModal(true)}><i className="far fa-edit" /> Editar Reclamação</button>
                    {data.status === ComplainHelper.Status.Pending ? 
                    <button className="btn btn-info btn-sm" onClick={()=> sendDirect()}><i className="si si-paper-plane" /> Liberação express</button>
                    :
                    <button className="btn btn-secondary btn-sm" onClick={()=> setShowResponseModal(true)}><i className="far fa-sticky-note" /> Registrar resposta</button>
                    }
                </div>
            </div>
            :
            <div className="block-header bg-dark text-white">
                <div className="block-title d-flex">
                    <i className="far fa-angry fa-2x mr-3 py-4" />
                    <p className="pb-0 mb-0">
                        <h3 className="m-0 text-white">{data && data.title && legibleTitle(data.title)} - {data && data.title && ComplainHelper.TranslateStatus(data.status)}</h3>
                        <span className="font-size-sm mr-3">ID: {data && !data.oldId ? data.createdDate.seconds :  data.oldId}</span>
                        <span className="font-size-sm mr-3">Nome: {data && data.user && data.user.name}</span>
                        <span className="font-size-sm mr-3">Telefone: {data && data.phone && data.phone}</span>
                        <br />
                        <small className="text-white">{data && data.createdDate && DateTranslate(data.createdDate)}</small> - {data && data.company && data.company.verified == true ? <i className="si si-check text-success" /> : <i className="si si-close text-danger" />} Empresa: {data && data.company && data.company.name}
                    </p>
                </div>
                <div className="block-tools">
                    <a className="btn btn-warning text-dark" href={`#/empresa/${data && data.companyId}?nome=${data && data.company && data.company.name}`} target="_blank"><i className="fa fa-search" /> Ver Empresa</a>
                    <button className="btn btn-white" onClick={()=> setShowModal(true)}><i className="far fa-edit" /> Editar Reclamação</button>
                    {data.status === ComplainHelper.Status.Pending ? 
                    <button className="btn btn-info" onClick={()=> sendDirect()}><i className="si si-paper-plane" /> Liberação express</button>
                    :
                    <button className="btn btn-secondary" onClick={()=> setShowResponseModal(true)}><i className="far fa-sticky-note" /> Registrar resposta</button>
                    }
                </div>
            </div>
            }
            <div className="block-content">
                <p style={{ whiteSpace: "pre-line" }}>
                    {data && data.description && legible(data.description)}
                </p>
                {selectedServices && selectedServices.length > 0 ?
                <div>
                    <div className="content-heading mt-0 pt-0">
                        <h4 className="text-muted">Serviços Selecionados</h4>
                    </div>
                    <ul>
                        {selectedServices.map(service => (
                            <li key={service.id}>{service.name}</li>
                        ))}
                    </ul>
                </div>
                 :""}
                {CheckMobile() ? 
                <div className="">
                        <button className="btn btn-sm btn-primary" onClick={()=> setShowComplainModal(true)} ><i className="far fa-eye" /> Visualizar</button>
                        <button className="btn btn-sm btn-warning text-dark"><i className="si si-paper-plane" /> Enviar ao comercial</button>
                        <button className="btn btn-sm btn-danger" onClick={()=> deleteComplain()}><i className="si si-trash" /> Excluir</button>
                </div>
            :
                <div className="row mb-4">
                    <div className="col-md-4">
                        <button className="btn btn-block btn-primary" onClick={()=> setShowComplainModal(true)} ><i className="far fa-eye" /> Ver reclamação</button>
                    </div>
                    <div className="col-md-4">
                        <button className="btn btn-block btn-warning text-dark"><i className="si si-paper-plane" /> Enviar para comercial</button>
                    </div>
                    <div className="col-md-4">
                        <button className="btn btn-block btn-danger" onClick={()=> deleteComplain()}><i className="si si-trash" /> Excluir</button>
                    </div>
                </div>
            }

            </div>
            <ComplainEditModal
                show={showModal}
                onHide={()=> setShowModal(false) | reload()}
                infos={data && data}
            />
            <ComplainModal
                show={showComplainModal}
                onHide={()=> setShowComplainModal(false) | reload()}
                infos={data && data}
            />
            <ComplainResponseModal
                show={showResponseModal}
                onHide={()=> setShowResponseModal(false) | reload()}
                infos={data && data}
            />
        </div>
    )
}